import packageJson from "../package.json"

/** The version of @quotientjs/client, read from package.json. */
export const SDK_VERSION: string = packageJson.version
